import React, { useState } from "react";
import { VerificationMail } from "src/pages/finalisation/etapes/verificationMail/codeMailSend/useValidationSchemaMail";
import CodeMailCheckContainer from "src/pages/finalisation/etapes/verificationMail/codeMailCheck/CodeMailCheckContainer";
import CodeMailFinalisation from "src/pages/finalisation/etapes/verificationMail/codeMailFinalisation/CodeMailFinalisation";
import CodeMailSendContainer from "src/pages/finalisation/etapes/verificationMail/codeMailSend/CodeMailSendContainer";

export type VerificationMailFormProps = {
  initialValues: VerificationMail;
  pageSuivante: (data: any) => void;
};


const VerificationMailForm = ({ initialValues, pageSuivante }: VerificationMailFormProps) => {
  const [currentStep, setCurrentStep] = useState(0);

  const handleStepSuivante = () => {
    setCurrentStep(currentStep + 1);
  }

  const handleStepPrecedente = () => {
    setCurrentStep(currentStep - 1);
  }

  return (
    <>
      {currentStep === 0 && <CodeMailSendContainer initialValues={initialValues} stepSuivante={handleStepSuivante} /> }
      {currentStep === 1 && <CodeMailCheckContainer initialValues={{...initialValues, code: ""}} stepSuivante={handleStepSuivante} stepPrecedente={handleStepPrecedente} /> }
      {currentStep === 2 && <CodeMailFinalisation pageSuivante={pageSuivante} /> }
    </>
  );
};

export default VerificationMailForm;